import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { CardBrand, DocumentPermission, DocumentStatus, FileTypeCategory, PaymentStatus } from '../enums/data.enums';

export const CARD_BRAND_DISPLAY_LABELS: Record<CardBrand, string> = {
  [CardBrand.Visa]:       'Visa',
  [CardBrand.Mastercard]: 'Mastercard',
  [CardBrand.Amex]:       'American Express',
  [CardBrand.Discover]:   'Discover',
  [CardBrand.Diners]:     'Diners Club',
  [CardBrand.Jcb]:        'JCB',
  [CardBrand.UnionPay]:   'UnionPay',
  [CardBrand.Unknown]:    'Card',
};

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  [PaymentStatus.Pending]:       'warning',
  [PaymentStatus.Succeeded]:     'success',
  [PaymentStatus.Failed]:        'danger',
  [PaymentStatus.Canceled]:      'secondary',
  [PaymentStatus.Refunded]:      'info',
  [PaymentStatus.Marked]:        'success',
  [PaymentStatus.Unmarked]:      'dark',
  [PaymentStatus.RefundPending]: 'warning',
  [PaymentStatus.Canceling]:     'warning',
};

// Document folder permission display — single source for the label/icon/badge/icon-color used
// across the documents feature (list tiles, move modal, permissions modal, current-folder header).
export const DOCUMENT_PERMISSION_LABELS: Record<DocumentPermission, string> = {
  [DocumentPermission.AdminOnly]:  'Admin only',
  [DocumentPermission.MemberRead]: 'Member read',
  [DocumentPermission.Public]:     'Public',
};

export const DOCUMENT_PERMISSION_ICONS: Record<DocumentPermission, string> = {
  [DocumentPermission.AdminOnly]:  'lock',
  [DocumentPermission.MemberRead]: 'users',
  [DocumentPermission.Public]:     'globe',
};

export const DOCUMENT_PERMISSION_BADGE_CLASSES: Record<DocumentPermission, string> = {
  [DocumentPermission.AdminOnly]:  'badge bg-secondary-subtle text-secondary-emphasis',
  [DocumentPermission.MemberRead]: 'badge bg-info-subtle text-info-emphasis',
  [DocumentPermission.Public]:     'badge bg-success-subtle text-success-emphasis',
};

export const DOCUMENT_PERMISSION_ICON_COLOR_CLASSES: Record<DocumentPermission, string> = {
  [DocumentPermission.AdminOnly]:  'text-secondary',
  [DocumentPermission.MemberRead]: 'text-info-emphasis',
  [DocumentPermission.Public]:     'text-success-emphasis',
};

// Document virus-scan status display (DEV-2394). Available is the expected state and shows no badge,
// so only Pending (scan in progress) and Quarantined (flagged, download blocked) surface to users.
export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, string> = {
  [DocumentStatus.Pending]:     'Pending',
  [DocumentStatus.Available]:   'Available',
  [DocumentStatus.Quarantined]: 'Quarantined',
};

export const DOCUMENT_STATUS_BADGE_CLASSES: Record<DocumentStatus, string> = {
  [DocumentStatus.Pending]:     'badge bg-warning-subtle text-warning-emphasis',
  [DocumentStatus.Available]:   'badge bg-success-subtle text-success-emphasis',
  [DocumentStatus.Quarantined]: 'badge bg-danger-subtle text-danger-emphasis',
};

// Fallback label for the documents list's Type column (DEV-2559) when a file's extension is
// missing/empty — derived from the broader category the API assigns. The extension is preferred when
// present (e.g. "PDF" from ".pdf") since it's more specific than the category (e.g. "Document" spans
// .doc/.docx/.txt/...).
export const DOCUMENT_FILE_TYPE_LABELS: Record<FileTypeCategory, string> = {
  [FileTypeCategory.Pdf]:         'PDF',
  [FileTypeCategory.Image]:       'Image',
  [FileTypeCategory.Document]:    'Document',
  [FileTypeCategory.Spreadsheet]: 'Spreadsheet',
  [FileTypeCategory.Video]:       'Video',
  [FileTypeCategory.Archive]:     'Archive',
  [FileTypeCategory.Other]:       'File',
};

export const CARD_BRAND_ICONS: Record<CardBrand, IconProp> = {
  [CardBrand.Visa]:       ['fab', 'cc-visa'],
  [CardBrand.Mastercard]: ['fab', 'cc-mastercard'],
  [CardBrand.Amex]:       ['fab', 'cc-amex'],
  [CardBrand.Discover]:   ['fab', 'cc-discover'],
  [CardBrand.Diners]:     ['fab', 'cc-diners-club'],
  [CardBrand.Jcb]:        ['fab', 'cc-jcb'],
  [CardBrand.UnionPay]:   ['fad', 'credit-card'],
  [CardBrand.Unknown]:    ['fad', 'credit-card'],
};
